/*
  Images pasted into product descriptions are output with a single full-size
  src. For images on Shopify's CDN, add a width-based srcset so the browser
  downloads a size that fits. Runs before lazy images come near the viewport.

  Skipped: SVG (the CDN can't resize it), images hosted elsewhere, images that
  already have a srcset, and URLs with a legacy size suffix (_1024x1024 etc.),
  which need fixing in the description itself.
*/
(function () {
  var WIDTHS = [400, 800, 1200, 1600];
  var SIZE_SUFFIX = /_(\d+x\d*|\d*x\d+)(_crop_\w+)?\.\w+$/i;

  function isShopifyImage(url) {
    return (
      url.pathname.indexOf('/cdn/shop/') !== -1 ||
      (url.hostname === 'cdn.shopify.com' && url.pathname.indexOf('/s/files/') !== -1)
    );
  }

  function addSrcset(img) {
    var src = img.getAttribute('src');
    if (!src || img.hasAttribute('srcset')) return;

    var url;
    try {
      url = new URL(src, window.location.href);
    } catch (error) {
      return;
    }

    if (!isShopifyImage(url) || /\.svg$/i.test(url.pathname) || SIZE_SUFFIX.test(url.pathname)) return;

    url.searchParams.delete('width');
    img.setAttribute(
      'srcset',
      WIDTHS.map(function (width) {
        var sized = new URL(url.href);
        sized.searchParams.set('width', width);
        return sized.href + ' ' + width + 'w';
      }).join(', ')
    );
    // "auto" lets supporting browsers use the lazy image's laid-out width.
    img.setAttribute('sizes', img.getAttribute('loading') === 'lazy' ? 'auto, 100vw' : '100vw');
  }

  function run() {
    var images = document.querySelectorAll('.product-description img, .tab-panel img, .rte img');
    for (var i = 0; i < images.length; i++) addSrcset(images[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
